<template lang="pug">
	span.compression-data
		span(v-if="isProcessing")
			span.compression-info Size:
				.icon.fa.fa-spinner.fa-spin
		span(v-else)
			span.compression-error(v-if="isError && isError.indexOf('TexturePacker::') > 0" v-html="isError.substr(isError.indexOf('TexturePacker::') + 16).replace(/TexturePacker::/g, '<br>')")
			span.compression-error(v-else-if="isError") Error: {{ isError }}
			span.compression-info(v-else-if="!isUnknown") {{ (this.sizeText || 'Size: ') + (new Intl.NumberFormat().format(Math.round(size / 1000))) }} kb
			span.compression-info(v-else="isUnknown") Asset size unknown
		span.unknown-button(v-if="isUnknown || isError" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Repack and calculate size'}" v-on:click="compressAssets()")
			li.fa.fa-refresh
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Asset } 			from '../../services/Asset';
	import { Monitoring } 		from './../../services/Monitoring';

	export default {
		name: "AssetCompressionData",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Creative Compression Data Loaded", "Selected Creative Compression Data Changed",
			"Selected Version Asset Added", "Selected Version Assets Changed", "Selected Version Assets Restored", "Selected Version Assets Deleted"],
			events: {
				"Asset Compression Data Changed": function() {
					this.update();
				}
			}
		},
		props: ['sizeText', 'assetCodenames', 'assetType'/*, 'compression', 'repack'*/],
		data() {

			this.Monitoring = Monitoring;

			return {
				showed: true,
				size: 0,
				isError: false,
				isProcessing: false,
				isUnknown: false
			};

		},
		methods: {
			collectData() {

				this.size = 0;
				this.isError = false;
				this.isProcessing = false;
				this.isUnknown = false;

				if (!Asset.selectedVersionAssetCompressionData) return;

				if (this.assetType) {

					if (this.assetType === 'all') {

						_.forEach(Asset.selectedVersionAssetCompressionData, value => {
							this.size += value.size;
							if (value.isProcessing) this.isProcessing = value.isProcessing;
							if (value.isError) this.isError = value.isError;
							if (value.isUnknown) this.isUnknown = value.isUnknown;
						});

					} else {

						if (Asset.selectedVersionAssetCompressionData[this.assetType]) {
							this.size = Asset.selectedVersionAssetCompressionData[this.assetType].size;
							this.isError = Asset.selectedVersionAssetCompressionData[this.assetType].isError;
							this.isProcessing = Asset.selectedVersionAssetCompressionData[this.assetType].isProcessing;
							this.isUnknown = Asset.selectedVersionAssetCompressionData[this.assetType].isUnknown;

						}

					}

				} else {

					this.size = Asset.getSize(this.assetCodenames);
					this.isProcessing = Asset.getProcessing(this.assetCodenames);
					this.isUnknown = Asset.getUnknown(this.assetCodenames);
					this.isError = Asset.getError(this.assetCodenames);
				}

			},
			compressAssets() {

				Asset.compressAssets(Version.SelectedVersion.id, this.assetCodenames);

			},
			getSize() {

				let size = 0;

				_.each(this.assetCodenames, assetCodename => {

					let compressionData = this.getCompressionData(assetCodename);

					if (compressionData && !compressionData.error) size += compressionData.size;

				});

				return size;

			},
			getProcessing() {

				let is_processing = false;

				_.each(this.assetCodenames, assetCodename => {

					let cacheKey = this.getCacheKey(assetCodename);

					if (Monitoring.activeProcesses['asset-compress'][cacheKey]) is_processing = true;

				});

				return is_processing;

			},
			getUnknown() {

				let is_unknown = false;

				_.each(this.assetCodenames, assetCodename => {

					let compressionData = this.getCompressionData(assetCodename);

					if (!compressionData) is_unknown = true;

				});

				return is_unknown;

			},
			getError() {

				let is_error = false;

				_.each(this.assetCodenames, assetCodename => {

					let compressionData = this.getCompressionData(assetCodename);

					if (compressionData && compressionData.error) is_error = compressionData.error;

				});

				return is_error;

			},
			getCacheKey(assetCodename) {

				let version = Version.SelectedVersion;
				if (!version) return '';

				let creative = Creative.getCreative(version['creative_id']);
				let asset = Asset.getAsset(version, assetCodename);

				return Asset.getAssetCompressionCacheFileName(creative, version, asset);

			},
			getCompressionData(assetCodename) {

				let version = Version.SelectedVersion;
				if (!version) return {size: null};

				let creative = Creative.getCreative(version['creative_id']);
				let asset = Asset.getAsset(version, assetCodename);

				if (!asset) return null;

				let cacheKey = Asset.getAssetCompressionCacheFileName(creative, version, asset);

				return Asset.CompressionCacheData[version['creative_id']][cacheKey];

			}
		}
	}
</script>

<style lang="sass">

	.compression-data
		line-height: 11px

		.compression-error
			line-height: 11px
			color: #f86c6b

		.compression-info
			line-height: 24px

		.fa-spinner.fa-spin
			margin: 0 5px 0 5px

		.unknown-button
			cursor: pointer
			transition: 0.2s
			padding: 2px 7px
			font-size: 14px
			color: #fff

			&:hover
				color: #20a8d8

</style>

